module.exports = __webpack_public_path__ + "files/35b4aad62a7d04ab75215d6a6f7c3106.png";